import { createAction, ActionType, createReducer } from 'typesafe-actions';

interface ModalPopup {
  [key: string]: {
    open: boolean;
  };
}

const initialState: ModalPopup = {
  ModalYoutubeManual: {
    open: true,
  },
  ModalAccountPopup: {
    open: true,
  },
};

// Youtube modal
export const OPEN_MODAL_YOUTUBE = 'ModalYoutubeManualReducer/OPEN_MODAL';
export const CLOSE_MODAL_YOUTUBE = 'ModalYoutubeManualReducer/CLOSE_MODAL';

export const openModalYoutubeManual = createAction(OPEN_MODAL_YOUTUBE)();
export const closeModalYoutubeManual = createAction(CLOSE_MODAL_YOUTUBE)();

// Account modal
export const OPEN_MODAL_ACCOUNT = 'ModalAccountPopup/OPEN_MODAL';
export const CLOSE_MODAL_ACCOUNT = 'ModalAccountPopup/CLOSE_MODAL';

export const openModalAccount = createAction(OPEN_MODAL_ACCOUNT)();
export const closeModalAccount = createAction(CLOSE_MODAL_ACCOUNT)();

export const actions = { openModalYoutubeManual, closeModalYoutubeManual, openModalAccount, closeModalAccount };

type ModalPopupActions = ActionType<typeof actions>;

const ModalYoutubeManualReducer = createReducer<ModalPopup, ModalPopupActions>(initialState, {
  [OPEN_MODAL_YOUTUBE]: state => {
    return {
      ...state,
      ModalYoutubeManual: {
        open: true,
      },
    };
  },
  [CLOSE_MODAL_YOUTUBE]: state => {
    return {
      ...state,
      ModalYoutubeManual: {
        open: false,
      },
    };
  },
  [OPEN_MODAL_ACCOUNT]: state => {
    return {
      ...state,
      ModalAccountPopup: {
        open: true,
      },
    };
  },
  [CLOSE_MODAL_ACCOUNT]: state => {
    return {
      ...state,
      ModalAccountPopup: {
        open: false,
      },
    };
  },
});

export default ModalYoutubeManualReducer;
